import React from 'react';
import { SvgIcon } from '@make-software/tg-mini-app-ui';

import TxSentIcon from '@/shared/assets/icons/ic-illustration-sent.svg';

import { RoundContainer } from '../styled';
import { ClaimedTitle } from './styled';

export const GiftClaimed: React.FC = () => {
  return (
    <RoundContainer
      align="center"
      justify="center"
      style={{ textAlign: 'center' }}
      padding="0 17px 32px 17px"
    >
      <SvgIcon src={TxSentIcon} size={240} />
      <ClaimedTitle weight={3} color="#FFFFFF">
        Your gift has been successfully claimed! Enjoy your new CSPR name 🎉
      </ClaimedTitle>
    </RoundContainer>
  );
};
